import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import type { OrgMemberRow } from 'pure-js/types/OrganizationMembership'

import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { LeaderScopePersonRow } from './LeaderScopePersonRow'
import { leaderScopeListSx, leaderScopeMutedTextSx } from './leaderScopeStyles'

export type LeaderScopePeopleListProps = {
  members: OrgMemberRow[]
  selectedUserIds: string[]
  onToggle: (userId: string) => void
}

/** Every participant of the organization, ticked or not. */
export const LeaderScopePeopleList: React.FC<LeaderScopePeopleListProps> = ({ members, selectedUserIds, onToggle }) => {
  const { t } = useTranslation()

  if (members.length === 0) {
    return <Typography sx={{ ...leaderScopeMutedTextSx, py: 2 }}>{t('org.leaderScope.noMatches')}</Typography>
  }

  return (
    <Box sx={leaderScopeListSx}>
      <Stack spacing={0.5}>
        {members.map((member) => (
          <LeaderScopePersonRow
            key={member.userId}
            member={member}
            isSelected={selectedUserIds.includes(member.userId)}
            onToggle={onToggle}
          />
        ))}
      </Stack>
    </Box>
  )
}
